<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  watch: {
    // 监听路由变化，滚动到顶部
    $route() {
      window.scrollTo(0, 0)
    }
  }
}</script>
<style lang="css" src="./assets/common.css">
</style>
